import Button from "@app/components/button/Button";
import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE, ResponseCode } from "@app/constants/Common";
import { requestSaveJobPipeline } from "@app/services/JobPipelineService";
import { capitalizeName } from "@app/utils/CommonUtils";
import InputMoreModal from "@pages/candidate/commonview/InputMoreModal";
import RefereeConfirmModal from "@pages/candidate/commonview/RefereeConfirmModal";
import {
    CddMeCheckStatusOptions,
    DVTJCUVPipelineCddConnectEmpBriefSentTableColumns,
    DVTJCUVPipelineP2TableColumns,
    DVTJCUVPipelineProcessedCddTableColumns,
    DVTJCUVPipelineSearchCddTableColumns,
    DVTJCUVPipelineTableColumns,
    DVTJCUVPipelineTablePColumns,
    DVTJCUVPipelineTableSearchReceiverColumns,
    DVTJCUVPipelineTableWColumns,
    DVTJCUVPipelineTableZColumns,
    DVTJCUVPipelineXTableColumns,
    DVTJCUVPipelineX2TableColumns,
    DVTJCUVPipelineYTableColumns,
    DVTJCUVPipelineSearchCddSummaryTableColumns,
    DVTJCUVPipelineSearchRecSummaryTableColumns,
    DVTJCUVPipelineSearchEmpSummaryTableColumns,
    JobFindModeOptions,
    ProcessPriorityOptions,
} from '@pages/dvtjcuv/common/Constant';
import { CannotEditPipelinesWithInternalProcess } from "@pages/jobpipeline/common/Constant";
import PipelineRefereeInputModal from "@pages/jobpipeline/list/PipelineRefereeInputModal";
import React, { useEffect, useState } from 'react';

import { alertMessage, showMessage } from "@app/constants/Messages";
import { EmailInviteMode } from '@app/pages/candidate/list/DVTJCUVEmailInviteModal';
import DVTJCUVEmailInviteModal from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import { DVTJCUVAcquireCddParentTabIds } from "@pages/dvtjcuv/common/AcquireCddTabs";
import { DVTJCUVConnectCddEmpParentTabs } from '@pages/dvtjcuv/common/ConnectCddEmpTabs';
import { findOneOptionByValue } from "@pages/dvtjcuv/common/PipelineUtil";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import { DVTJCUVWorkWithRecParentTabs, DVTJCUVWorkWithRecSendEmailInviteJobTabs } from '@pages/dvtjcuv/common/WorkWithRecTabs';
import DVTJCUVEmployerSummaryModal from "@pages/dvtjcuv/list/DVTJCUVEmployerSummaryModal";
import InputCddGPEmpDiscussionModal, {
    CddGPEmpDiscussionMode
} from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal';
import InputDiscussionWCddAcquireModal from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputDiscussionWCddAcquireModal';
import DVTJCUVSearchCddJobModal from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobModal";
import { requestDeleteDVTJCUVPipeline, requestSaveDVTJCUVPipeline } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import { requestStartRunDVTJCUV } from '@pages/dvtjcuv/service/DVTJCUVService';
import { DVTJCUVCddOpenAndNotSddvParentTabs } from '../common/CddOpenAndNotSddvTabs';



const CHANGE_COLOR_COLUMNS = ['interactive_channel', 'ctv_status', 'process_info_from_ctv',
    'refer_status', 'refer_info_process', 'cdd_status', 'user_qualify_uv',
    'todo_with_person',
    'internal_process', 'cdd_to_employer_process', 'payment_and_warranty']

export const DVTJCUVPipelineListMode = {
    PIPELINE_LIST: 1,
    RUN_FOLLOW_UP: 2,
    RUN_DVTJCUV_CONNECT_CDD_EMP: 3,
    RUN_DVTJCUV_SEARCH_CDD: 4,
    RUN_DVTJCUV_ACQUIRE_CDD: 5,
    RUN_DVTJCUV_SEARCH_JOB_CDD: 6,
    DVTJCUV_SEARCH_EMPLOYER: 7,
    DVTJCUV_EMPLOYER_SUMMARY_FULL: 8,
    DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD: 9,
    DVTJCUV_SEARCH_CDD_SUMMARY: 10,
    DVTJCUV_SEARCH_REC_SUMMARY: 11,
    DVTJCUV_SEARCH_EMP_SUMMARY: 12,
    // RUN_DVTJCUV_SEARCH_CDD_RECEIVER: 10,
    // RUN_DVTJCUV_RECEIVERS_AUTO_RELEASED: 7,
    // RUN_DVTJCUV_RECEIVERS_MANUALLY_RELEASED: 8,
    // RUN_DVTJCUV_RECEIVERS_SENT: 9,
    // RUN_DVTJCUV_PAYMENT_WARRANTY: 10,
}

const DVTJCUVPipelineTableList = (props) => {
    const [pipeLineList, setPipeLineList] = useState([]);
    const [tableColumns, setTableColumns] = useState([...DVTJCUVPipelineTableColumns]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectRow, setSelectRow] = useState({});
    const [showInputMoreModal, setShowInputMoreModal] = useState(false);
    const [hiddenColumns, setHiddenColumns] = useState({});
    const [inputMoreColumn, setInputMoreColumn] = useState({rowIndex: -1, column: {}});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [sortColumnInfo, setSortColumnInfo] = useState({});
    const [showRefereeConfirmModal, setShowRefereeConfirmModal] = useState(false);
    const [showRefereeInputModal, setShowRefereeInputModal] = useState(false);
    const [showBtnAddPipeline, setShowBtnAddPipeline] = useState(false);
    const [showInputCddGPEmpDiscussionModal, setShowInputCddGPEmpDiscussionModal] = useState(false);
    const [showInputDiscussionWithCddAcquireModal, setShowInputDiscussionWithCddAcquireModal] = useState(false);
    const [openDVTJCUVEmpSummaryModal, setOpenDVTJCUVEmpSummaryModal] = useState(false);
    const [isShowSearchCddJobModal, setShowSearchCddJobModal] = useState(false);
    const [isSelectedAll, setSelectedAll] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const {
        cddId,
        pipeLines,
        hideColumns,
        sortColumn,
        mode,
        cddIsReceiver,
        showBtnSelect,
        showBtnAddPipelineOnRefereeInput,
        parentTabId,
        subTabId,
        onEditItem,
        onClose,
        onSort,
        onSelectItems,
    } = props

    useEffect(() => {
        const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        if (!userLoginInfo.id && strUserLogin) {
            setUserLoginInfo(JSON.parse(strUserLogin))
        }
    }, [])

    const getProcessPriorityValue = (processPriority) => {
        if (processPriority) {
            const foundOption = ProcessPriorityOptions.find(option => option.value.toString() === processPriority.toString())
            return foundOption ? foundOption.label : ""
        }
        return ""
    }
    useEffect(() => {
        // if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD
        //     && parentTabId === DVTJCUVSearchCddJobParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
        //     // Sắp xếp theo tiêu chí:
        //     // trường "FU needed (Cdd-Emp)" = 1 trong các giá trị Follow up Cdd hoặc Follow up Emp
        //     // thì xếp lên trên và dòng nào có Note time mới hơn, thì được hiển thị trước.
        //     const followUpValues = ["follow up cdd", "follow up emp"];
        //     const firstDisplayItems = []
        //     const secondsDisplayItems = []
        //     const sortPipeLines =  pipeLines.sort((a, b) => {
        //         return b.id - a.id;
        //     });

        //     sortPipeLines.forEach(item => {
        //         if (item.cdd_emp_fu_needed && followUpValues.includes(item.cdd_emp_fu_needed.toLowerCase())) {
        //             firstDisplayItems.push(item);
        //         } else {
        //             secondsDisplayItems.push(item);
        //         }
        //     })
        //     //
        //     setPipeLineList([...firstDisplayItems, ...secondsDisplayItems])
        // } else
        
        if (parentTabId === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id
            || parentTabId === DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id) {
            // group by unique cdd_id
            const outPipelines = []
            const outCddIds = []
            pipeLines.forEach(item => {
                if (item.cdd_id && !outCddIds.includes(item.cdd_id)) {
                    outCddIds.push(item.cdd_id)
                    outPipelines.push(item)
                }
            })
            // sort by sortColumnInfo. sortColumnInfo is a object with key is column key and value is order by type
            const sortedPipelines = outPipelines.sort((a, b) => {
                return sortColumnInfo[a.key] - sortColumnInfo[b.key]
            })
            setPipeLineList(sortedPipelines.map(((item,index) => {
                item.no = index+1
                return item
            })))
        } else {
            const sortedPipelines = pipeLines.sort((a, b) => {
                return sortColumnInfo[a.key] - sortColumnInfo[b.key]
            })
            setPipeLineList(sortedPipelines.map(((item,index) => {
                item.no = index+1
                return item
            })))
        }

    }, [pipeLines]);

    useEffect(() => {
        setSortColumnInfo({...sortColumn})
    }, [sortColumn]);

    useEffect(() => {
        if (hideColumns) {
            setHiddenColumns({...hideColumns})
        }
    }, [hideColumns]);

    useEffect(() => {
        setShowBtnAddPipeline(showBtnAddPipelineOnRefereeInput)
    }, [showBtnAddPipelineOnRefereeInput]);

    const isShowYPipelineTable = () => {
        return (parentTabId === DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id
            || parentTabId === DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id
            || parentTabId === DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id
            || parentTabId === DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id
            || parentTabId === DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id)
    }

    useEffect(() => {
        if (mode ===DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) {
            if (cddIsReceiver) {
                setTableColumns([...DVTJCUVPipelineTableSearchReceiverColumns])
            }
            else {
                setTableColumns([...DVTJCUVPipelineSearchCddTableColumns])
            }
        } else if (mode === DVTJCUVPipelineListMode.DVTJCUV_SEARCH_CDD_SUMMARY) {
            setTableColumns([...DVTJCUVPipelineSearchCddSummaryTableColumns])
        } else if (mode === DVTJCUVPipelineListMode.DVTJCUV_SEARCH_REC_SUMMARY) {
            setTableColumns([...DVTJCUVPipelineSearchRecSummaryTableColumns])
        } else if (mode === DVTJCUVPipelineListMode.DVTJCUV_SEARCH_EMP_SUMMARY) {
            setTableColumns([...DVTJCUVPipelineSearchEmpSummaryTableColumns])
        } else if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP) {
            if (parentTabId === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id
                || parentTabId === DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id) {
                setTableColumns([...DVTJCUVPipelineCddConnectEmpBriefSentTableColumns])
            } else if (parentTabId === DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id
                 || parentTabId === DVTJCUVCddOpenAndNotSddvParentTabs.PRIORITY_PROCESS_TAB.id) {
                setTableColumns([...DVTJCUVPipelineTableWColumns])
            } else if (parentTabId === DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
                setTableColumns([...DVTJCUVPipelineTablePColumns])
            }
        } else if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) {
            if (parentTabId === DVTJCUVSearchCddJobParentTabs.SET_RECEIVER_LIST_TAB.id) {
                if (subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
                    || subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id) {
                    setTableColumns([...DVTJCUVPipelineTableZColumns])
                }
            } else if (isShowYPipelineTable()) {
                setTableColumns([...DVTJCUVPipelineYTableColumns])
            } else if (parentTabId === DVTJCUVSearchCddJobParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
                setTableColumns([...DVTJCUVPipelineP2TableColumns])
            } else if (parentTabId === DVTJCUVSearchCddJobParentTabs.PROCESS_FEEDBACK_TAB.id) {
                setTableColumns([...DVTJCUVPipelineTableColumns])
            }
        } else if (mode === DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD) {
            setTableColumns([...DVTJCUVPipelineProcessedCddTableColumns])
        } else if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD) {
            if (parentTabId === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB
                || parentTabId === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
                || parentTabId === DVTJCUVAcquireCddParentTabIds.HOT_JOB_NOT_HAS_PLAN_TAB
                || parentTabId === DVTJCUVAcquireCddParentTabIds.UV_NEED_REP_TAB
                || parentTabId === DVTJCUVAcquireCddParentTabIds.PENDING_PROCESS_TAB
                || parentTabId === DVTJCUVAcquireCddParentTabIds.SERVICE_EXPIRE_TAB
            ) {
                setTableColumns([...DVTJCUVPipelineXTableColumns])
            }
            if (parentTabId === DVTJCUVWorkWithRecSendEmailInviteJobTabs.NEED_FU_TAB.id) {
                setTableColumns([...DVTJCUVPipelineX2TableColumns])
            }
        }
        else {
            setTableColumns([...DVTJCUVPipelineTableColumns])
        }
    }, [mode, parentTabId]);


    const onDeletePipeLine = (id) => {
        let text = "Bạn chắc chắn muốn xóa Job Pipeline này?";
        if (window.confirm(text) === true) {
            setIsLoading(true)
            requestDeleteDVTJCUVPipeline({id: id}).then((res) => {
                alertMessage(res.sts_code, false, true)
                onClose(true)
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            }).finally(() => {
                setIsLoading(false)
            });
        }
    }

    const onDeleteItem = (item, index) => {
        setSelectRow(item)
        onDeletePipeLine(item.id)
    }

    const onDuplicateItem = (item) => {
        const newItem = {...item}
        newItem.id = ""
        onEditItem(newItem)
    }

    const onShowInputMoreColumn = (fieldKey, index) => {
        const columns = DVTJCUVPipelineTableColumns.filter(item => {
            return item.key === fieldKey
        })
        setInputMoreColumn({rowIndex: index, column: columns[0]})
        setShowInputMoreModal(true)
    }

    const onCloseInputMoreColumn = () => {
        setInputMoreColumn({rowIndex: -1, column: {}})
        setShowInputMoreModal(false)
    }

    const onSaveInputMore = (value) => {
        console.log("onSaveInputMore:" + value)
        const fieldKey = inputMoreColumn.column.key
        const selectJP = pipeLineList[inputMoreColumn.rowIndex]
        const body = {id: selectJP.id}
        body[fieldKey] = value
        setIsLoading(true);
        requestSaveDVTJCUVPipeline(body).then((res) => {
            selectJP[fieldKey] = value
            setPipeLineList([...pipeLineList])
            onCloseInputMoreColumn();
            alertMessage(res.sts_code, false, true)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onShowConfirmRefereeModal = (item) => {
        setSelectRow(item)
        setShowRefereeConfirmModal(true)
    }

    const onShowInputRefereeModal = (confirmInput) => {
        selectRow.confirmInputReferee = confirmInput
        setSelectRow({...selectRow})
        setShowRefereeConfirmModal(false)
        setShowRefereeInputModal(true);
    }

    const onFinishInputReferee = (newCandidateId, refereePipelineId) => {
        const newItem = {
            id: "",
            job_id: selectRow.job_id,
            job_name: selectRow.job_name,
            candidate_id: newCandidateId,
            referer_id: selectRow.candidate_id,
            comment_from_referer: selectRow.confirmInputReferee?.commentAboutPerson,
            internal_process: "target",

            // pipeline id gốc, record mà user lick vào action nhập referee
            // Khi lưu, nếu truyền thông tin origin_pipeline_id lên server, pm sẽ update referee_id
            // của pipeline gốc(id=origin_pipeline_id) thành newCandidateId
            origin_pipeline_id: selectRow.id
        }
        onEditItem(newItem, true)
    }

    const onClickSortColumn = (column) => {
        // alert("sort:" + column.key)
        if (onSort) {
            onSort(column.key)
        }
    }

    const classSortingType = (column) => {
        const sortType = sortColumnInfo[column.key]
        if (sortType) {
            return sortType === ODER_BY_TYPE.DESC ? 'sorting_desc' : 'sorting_asc'
        }

        return ""
    }
    const classColoumnHeaderColor = (column) => {
        if (column.group % 2 === 1) {
            return "text-danger"
        }

        return ""
    }

    const displayColumnValue = (column, value) => {
        if (column.key === 'current_find_job_mode') {
            const option = findOneOptionByValue(JobFindModeOptions, value)
            if (option) {
                return option.label
            }
        }
        if (column.key === 'cdd_me_check_status'
             || column.key === 'cdd_receiver_me_check_status') {
            const option = findOneOptionByValue(CddMeCheckStatusOptions, value)
            if (option) {
                return option.label
            }
        }
        if (column.key === 'process_priority') {
            return getProcessPriorityValue(value)
        }

        if (value && column.capitalize) {
            return capitalizeName(value)
        }

        return value
    }

    const bgCellColor = (column, changeFields) => {
        if (CHANGE_COLOR_COLUMNS.includes(column.key) && changeFields && changeFields.length > 0 && changeFields.includes(column.key)) {
            return "bg-warning"
        }
        return ""
    }

    const tableResponse = () => {
        // if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) {
        //     return ""
        // }

        if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) {
            if (subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
                || subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id
                || parentTabId === DVTJCUVSearchCddJobParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
                return ""
            }
        }

        if (mode === DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD
            || mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) {
            return ""
        }

        return "table-responsive"
    }

    const actionColumnFix = () => {
        if (mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) {
            if (subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
                || subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id
                || parentTabId === DVTJCUVSearchCddJobParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
                return ""
            }
        }

        if (mode === DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD
                || mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) {
            return ""
        }

        return "table-action-column-right-fixed"
    }

    const onInputGPEmpDiscussion = (item) => {
        setSelectRow(item)
        setShowInputCddGPEmpDiscussionModal(true)
    }

    const onInputDiscussionWithCddAcquire = (item) => {
        setSelectRow(item)
        setShowInputDiscussionWithCddAcquireModal(true)
    }



    const getSelectedItems = (pps) => {
        return pps.filter(item => item.isSelected)
    }

    const onSelectedAll = () => {
        const ppList = pipeLineList.map(item => {
            item.isSelected = !isSelectedAll
            return item
        })

        setPipeLineList([...ppList])
        if (!isSelectedAll) {
            setSelectedCount(pipeLineList.length)
        } else {
            setSelectedCount(0)
        }

        setSelectedAll(!isSelectedAll)

        if (onSelectItems) {
            onSelectItems(getSelectedItems(ppList))
        }
    };

    const onSelectedItem = (index) => {
        pipeLineList[index].isSelected = !pipeLineList[index].isSelected
        if (pipeLineList[index].isSelected) {
            setSelectedCount(selectedCount + 1)
        } else {
            setSelectedCount(selectedCount - 1)
            setSelectedAll(false)
        }
        setPipeLineList([...pipeLineList])
        if (onSelectItems) {
            onSelectItems(getSelectedItems(pipeLineList))
        }

    };

    const displayColumnTitle = (column) => {
        if (cddIsReceiver && column.key === 'cdd_id') {
            return 'Cdd Receiver Id'
        }
        return column.label
    }

    const processRequestStartRunDVTJCUV = (condition) => {
        requestStartRunDVTJCUV(condition).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const inviteResult = res.content.email_tab
                const notPermissionCandidateIds = inviteResult.not_permission_email_candidate_ids
                const needCheckingCandidateIds = inviteResult.need_checking_candidate_ids
                const needInputInfoCandidateIds = inviteResult.need_input_info_candidate_ids
                const approveDraftCandidateIds = inviteResult.approve_draft_candidate_ids
                let tabNo = 3;
                showMessage(
                    `
                    Kết quả check:
                    Số UV tab ${tabNo}.1: ${approveDraftCandidateIds.length}
                    Số UV tab ${tabNo}.2: ${notPermissionCandidateIds.length}
                    Số UV tab ${tabNo}.3: ${needCheckingCandidateIds.length}
                    Số UV tab ${tabNo}.4: ${needInputInfoCandidateIds.length}`
                )
                window.location.href = "dvtjcuv/acquire-cdd#dvtjcuv-acquire-cdd-fu-email-tab";
            } else {
                alertMessage(res.sts_code, true, false);
            }
        })
    }

    const onEmailFU = async (pipelines) => {
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true)
        setSelectedPipelines(pipelines)
        setShowFollowUpModal(true)
    }

    // const onEmailFU = async (candidateIds) => {
        
    //     const condition = {
    //         candidate_ids: candidateIds,
    //         invite_mode: EmailInviteMode.INVITE_EMAIL_FU

    //     }
        
    //     processRequestStartRunDVTJCUV(condition)
    // }

    return (
        <>
            <table
                className={`table table-bordered table-hover dataTable dtr-inline text-nowrap text-center ${tableResponse()}`}
            >
                <thead>
                <tr>
                    {showBtnSelect &&
                        <th style={{paddingRight: 10}}>
                            <input type="checkbox"
                                   style={{width: 20, height: 20}}
                                   checked={isSelectedAll}
                                   onChange={event => onSelectedAll(event)}
                            />
                        </th>
                    }
                    <th className={""}>No.</th>
                    {tableColumns.map(item => {
                        console.log("item.key:", item.key)
                        console.log("cddIsReceiver:", cddIsReceiver)
                        console.log("parentTabId:", parentTabId)
                        if (cddIsReceiver
                            && parentTabId === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                            && item.key === 'cdd_id'
                        ) {
                            // Hiển thị receiver_cdd thay cho cdd_id
                            item.key = 'cdd_receiver'
                            item.label = 'Receiver Cdd ID'
                        }
                        if (!hiddenColumns[item.key]) {
                            return <th className={`sorting ${classSortingType(item)} ${classColoumnHeaderColor(item)}`}
                                       onClick={() => onClickSortColumn(item)}
                                    //    style={{color: 'red'}}
                                       key={`DVTJCUVPipelineTableColumns_th_${item.key}`}>{displayColumnTitle(item)}</th>
                        }
                        return ""
                    })}
                    <th className={""} style={{minWidth: 83}}>Hành động</th>
                </tr>
                </thead>
                <tbody>
                {pipeLineList && pipeLineList.length > 0 && pipeLineList.map((item, index) => {
                    // Check xem item có thể edit được hay không
                    let canEdit = (userLoginInfo.is_superuser || (userLoginInfo.id === item.created_user
                        && !CannotEditPipelinesWithInternalProcess.includes(item.internal_process) && !item.is_over_allow_edit_time));
                    let changeFields = item.change_fields
                    // let strChangeFields = item.change_fields
                    // // Get thông tin fields change để setting màu sắc
                    // if (strChangeFields) {
                    //     changeFields = JSON.parse(strChangeFields)['fields']
                    // }
                    return <tr key={`DVTJCUVPipeline_${index}`} className={`${item.hightlight_class}`}>
                        {showBtnSelect &&
                            <td style={{paddingLeft: '.75rem'}}>
                                <input type="checkbox"
                                       style={{width: 20, height: 20}}
                                    // value={!!searchConditions.only_user_input}
                                       checked={item.isSelected}
                                       onChange={() => onSelectedItem(index)}
                                />
                            </td>
                        }
                        <td className={'text-center'}>{item.no ? item.no : index + 1}</td>
                        {tableColumns.map(field => {
                            if (!hiddenColumns[field.key]) {
                                if (field.displayType === 'link') {
                                    return <td className={`${field.classNames} text-truncate ${bgCellColor(field, changeFields)}`} style={{maxWidth: 200}}
                                               key={`piplentablelist_row_${index}_column_${field.key}`}>
                                        <a href={`${field.link}${item[field.key]}`} target="_blank"
                                           rel="noreferrer"
                                           className={'text-primary font-weight-bold'}>{displayColumnValue(field, item[field.key])}</a>
                                    </td>
                                }

                                return <td className={`${field.classNames} text-truncate ${bgCellColor(field, changeFields)} ${field.color ? field.color : ''}`} style={{maxWidth: 200}}
                                           key={`piplentablelist_row_${index}_column_${field.key}`}>
                                    {displayColumnValue(field, item[field.key])}
                                </td>
                            }
                            return ""
                        })}

                        <td className={actionColumnFix()}>
                            {mode !== DVTJCUVPipelineListMode.RUN_FOLLOW_UP &&
                            <div className="btn-group">
                                <button type="button" className="btn btn-info btn-sm">Actions</button>
                                <button type="button" className="btn btn-info btn-sm dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    <>
                                        {mode !== DVTJCUVPipelineListMode.RUN_FOLLOW_UP
                                            && mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD
                                            && mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD
                                            && parentTabId !== DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id
                                            && mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD
                                            && parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id
                                            && parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                            !(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) &&
                                            <>
                                                <Button onClick={() => onDeleteItem(item, index)}
                                                        disabled={!userLoginInfo.is_superuser}
                                                        className={'dropdown-item'}>
                                                    Xóa
                                                </Button>
                                                {parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                                parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id &&
                                                <>
                                                    <Button onClick={() => {
                                                        onShowConfirmRefereeModal(item)
                                                    }}
                                                        disabled={!canEdit}
                                                        className={'dropdown-item mr-2'}>
                                                        Nhập Referee
                                                    </Button>
                                                    <Button onClick={() => {
                                                    }}
                                                        disabled={!canEdit}
                                                        className={'dropdown-item mr-2'}>
                                                        Email link
                                                    </Button>
                                                    <Button onClick={() => {
                                                        onShowInputMoreColumn('note_discussion_w_cdd', index)
                                                    }} disabled={!canEdit} className={'dropdown-item mr-2'}>
                                                        Note Discussion w Cdd
                                                    </Button>
                                                    <Button onClick={() => {
                                                        onShowInputMoreColumn('note_discussion_w_receiver', index)
                                                    }} disabled={!canEdit} className={'dropdown-item mr-2'}>
                                                       Note Discussion w Receiver
                                                    </Button>
                                                    <a href={`/dvtjcuv/connect-cdd-emp#dvtjcuv-connect-cdd-emp-send-email-receiver-update-info-tab`}
                                                        target={'_blank'}
                                                        rel="noopener noreferrer"
                                                        className={'dropdown-item mr-2'}>
                                                        Gửi email đn Receiver update info
                                                    </a>
                                                </>
                                                }
                                            </>
                                        }
                                        {(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD
                                                || mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP
                                                || mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) &&
                                            <>
                                            {(parentTabId === DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id
                                                || parentTabId === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id
                                                || parentTabId === DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id
                                            ) &&
                                                <Button onClick={() => onInputGPEmpDiscussion(item)}
                                                    className={'dropdown-item mr-2'}>
                                                    Nhập Cdd-GP-Emp Discussion
                                                </Button>
                                            }
                                            {parentTabId !== DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id &&
                                            mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                                <Button onClick={() => onInputDiscussionWithCddAcquire(item)}
                                                        className={'dropdown-item mr-2'}>
                                                    Nhập Discussion w Cdd (Acquire)
                                                </Button>
                                            }
                                            {parentTabId !== DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id &&
                                             parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                             parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id &&
                                             mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                                <a href={`/dvtjcuv/connect-cdd-emp#dvtjcuv-connect-cdd-emp-send-email-receiver-update-info-tab`}
                                                   target={'_blank'}
                                                   rel="noopener noreferrer"
                                                   className={'dropdown-item mr-2'}>
                                                    Gửi email đn Receiver update info
                                                </a>
                                            }
                                            {parentTabId !== DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id &&
                                             parentTabId !== DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id &&
                                             mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                             !isShowYPipelineTable() &&
                                            <Button onClick={() => {
                                                setSelectRow(item)
                                                setShowSearchCddJobModal(true)
                                            }}
                                                    className={'dropdown-item mr-2'}>
                                                Tìm job cho Cdd
                                            </Button>
                                            }
                                            
                                            {parentTabId !== DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id &&
                                            mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                            isShowYPipelineTable() &&
                                                <Button onClick={() => {
                                                }}
                                                        className={'dropdown-item mr-2'}>
                                                    Nhập Ref Check
                                                </Button>
                                            }
                                            {parentTabId !== DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                            parentTabId !== DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_FU_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.NEED_REP_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.PROCESS_ENDED_TAB.id &&
                                            parentTabId !== DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id &&
                                            isShowYPipelineTable() &&
                                                <Button onClick={() => onEmailFU([item])}
                                                        className={'dropdown-item mr-2'}>
                                                    Gửi Email FU (DVTJCUV)
                                                </Button>
                                            }
                                            <Button onClick={() => {
                                            }}
                                                    className={'dropdown-item mr-2'}>
                                                Rep Email
                                            </Button>
                                            <Button onClick={() => {
                                            }}
                                                    className={'dropdown-item mr-2'}>
                                                Fw Email
                                            </Button>
                                            <Button onClick={() => {
                                            }}
                                                    className={'dropdown-item mr-2'}>
                                                Mở rộng
                                            </Button>
                                        </>
                                        }
                                        {/* Chỉ hiển thị các nút Edit, Duplicate khi không phải là chế độ RUN_DVTJCUV_SEARCH_CDD và không phải là cdd receiver */}
                                        {!(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) &&
                                        <>
                                            <Button onClick={() => onEditItem(item)}
                                                            disabled={!canEdit}
                                                            className={'dropdown-item mr-2'}>
                                                        Edit
                                            </Button>

                                            <Button onClick={() => onDuplicateItem(item)}
                                                            className={'dropdown-item mr-2'}>
                                                        Duplicate
                                            </Button>
                                        </>
                                        }

                                        {/*{parentTabId === DVTJCUVSearchCddJobParentTabs.SET_RECEIVER_LIST_TAB.id*/}
                                        {/*    && (subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id*/}
                                        {/*        || subTabId === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id) &&*/}
                                        {/*    <>*/}
                                        {/*        <Button onClick={() => onStartCheckEmailBriefConditions()}*/}
                                        {/*                className={'dropdown-item mr-2'}>*/}
                                        {/*            Gửi email Brief UV*/}
                                        {/*        </Button>*/}
                                        {/*    </>*/}
                                        {/*}*/}

                                        {mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                            <>
                                                <Button onClick={() => onInputGPEmpDiscussion(item)}
                                                        className={'dropdown-item mr-2'}>
                                                    Nhập Cdd-GP-Emp Discussion
                                                </Button>
                                            </>
                                        }

                                        {mode === DVTJCUVPipelineListMode.DVTJCUV_EMPLOYER_SUMMARY_PROCESSED_CDD &&
                                            <>
                                                <a href={`/dvtjcuv/list?cddId=${item.cdd_id || ''}&&employerId=${item.employer_id || ''}`}
                                                   target={'_blank'}
                                                   rel="noopener noreferrer"
                                                   className={'dropdown-item mr-2'}>
                                                    Pipelines
                                                </a>
                                            </>
                                        }

                                        {mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD && cddIsReceiver &&
                                            <Button onClick={() => onInputGPEmpDiscussion(item)}
                                                className={'dropdown-item mr-2'}>
                                                Nhập Cdd-GP-Emp Discussion
                                            </Button>
                                        }

                                        {(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD && !cddIsReceiver) &&
                                        mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                        <a href={`/dvtjcuv/list?cddId=${item.cdd_id || ''}&&pipelineHistory=true`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Pipeline history
                                        </a>
                                        }
                                        {(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD && cddIsReceiver) &&
                                        <a href={`/dvtjcuv/list?recId=${item.cdd_receiver_id || ''}&&pipelineHistory=true`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Pipeline history
                                        </a>
                                        }
                                        {!(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_CDD) &&
                                        mode !== DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD &&
                                        <a href={`/dvtjcuv/list?cddId=${item.cdd_id || ''}&&onlyShowlatestPipeline=true`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Latest Pipeline
                                        </a>
                                        }
                                        {!(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) && cddIsReceiver &&
                                        <a href={`/dvtjcuv/receiver-summary?recId=${item.cdd_receiver_id || ''}&&cddId=`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Tổng hợp theo Receiver
                                        </a>
                                        }
                                        {!(mode === DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD) && !cddIsReceiver &&
                                        <a href={`/dvtjcuv/receiver-summary?cddId=${item.cdd_id || ''}&&recId=`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Tổng hợp theo Cdd
                                        </a>
                                        }
                                    </>
                                </div>
                            </div>
                            }
                        </td>
                    </tr>
                })}
                </tbody>
            </table>
            {inputMoreColumn.rowIndex > -1 &&
                <InputMoreModal isShow={showInputMoreModal}
                                onClose={() => onCloseInputMoreColumn()}
                                onSave={(input) => onSaveInputMore(input)}
                                fieldTitle={inputMoreColumn.column?.label}
                                inputValue={pipeLineList[inputMoreColumn.rowIndex][inputMoreColumn.column?.key]}/>
            }
            {showRefereeConfirmModal &&
            <RefereeConfirmModal isShow={showRefereeConfirmModal}
                                 refererId={selectRow.candidate_id}
                                 jobId={selectRow.job_id}
                                 isFromPipeline
                                 onNext={(confirmInput) => {onShowInputRefereeModal(confirmInput)}}
                                 onClose={() => {setShowRefereeConfirmModal(false)}}
            />
            }
            {showRefereeInputModal &&
            <PipelineRefereeInputModal isShow={showRefereeInputModal}
                                       showBtnAddPipeline={showBtnAddPipeline}
                                       jobPipeline={selectRow}
                                       onNext={(newCandidateId, refereePipelineId) => onFinishInputReferee(newCandidateId, refereePipelineId)}
                                       onClose={() => {
                                           setShowRefereeInputModal(false)
                                       }}
            />
            }

            {showInputCddGPEmpDiscussionModal &&
                <InputCddGPEmpDiscussionModal
                    pipelineInfo={selectRow}
                    mode={parentTabId === DVTJCUVSearchCddJobParentTabs.PAYMENT_AND_WARRANTY_TAB.id ?
                        CddGPEmpDiscussionMode.PAYMENT_AND_WARRANTY : CddGPEmpDiscussionMode.DEFAULT
                    }
                    onClose={() => setShowInputCddGPEmpDiscussionModal(false)}
                    isShow={showInputCddGPEmpDiscussionModal} />
            }

            {showInputDiscussionWithCddAcquireModal &&
                <InputDiscussionWCddAcquireModal
                    pipelineInfo={selectRow}
                    onClose={() => setShowInputDiscussionWithCddAcquireModal(false)}
                    isShow={showInputDiscussionWithCddAcquireModal} />
            }

            {openDVTJCUVEmpSummaryModal &&
                <DVTJCUVEmployerSummaryModal
                    employer={{id: selectRow.employer_id}}
                    onClose={() => setOpenDVTJCUVEmpSummaryModal(false)}
                    isShow={openDVTJCUVEmpSummaryModal} />
            }

            {isShowSearchCddJobModal &&
                <DVTJCUVSearchCddJobModal
                    cddId={selectRow.cdd_id}
                    isShow={isShowSearchCddJobModal}
                    onClose={() => setShowSearchCddJobModal(false)}
                />
            }
            {/* {showFollowUpModal &&
            <DVTJCUVEmailFollowUpModal candidateIds={selectedCandidateIds}
                                     onClose={() => setShowFollowUpModal(false)}
                                     isShow={showFollowUpModal}/>
            } */}

            {showFollowUpModal &&
                <DVTJCUVEmailInviteModal candidateIds={[...new Set(selectedPipelines.map(item => item.cdd_id))]}
                                         pipelines={selectedPipelines}
                                         mode={EmailInviteMode.INVITE_EMAIL_FU}
                                         onClose={() => setShowFollowUpModal(false)}
                                         isShow={showFollowUpModal}/>
            }
        </>
    );
};

export default DVTJCUVPipelineTableList;
